import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Intent } from './intent';

import { AppConfigService } from '../app-config.service';

@Injectable()
export class OmniSearchService {
  private intents$$: BehaviorSubject<Intent[]> = new BehaviorSubject([]);
  private intentSet: Set<string> = new Set();

  intents$: Observable<Intent[]> = this.intents$$.asObservable();

  constructor(private config: AppConfigService) {}

  registerIntent(intent: Intent): void {
    if (!this.intentSet.has(intent.title)) {
      this.intents$$.next([...this.intents$$.getValue(), intent]);
      this.intentSet.add(intent.title);
    }
  }
}
